
       const __ReactNativeSvgLoader = require('react-native-svg-transformer-fix-expo').default({
  "replaceAttrValues": {
    "#000": "{props.color}"
  }
});
        import Input from '@ui/atoms/Input';

  const EyeSlashIcon = __ReactNativeSvgLoader(import('@src/assets/icons/eyeSlash.svg'));
  ;

  const EyeIcon = __ReactNativeSvgLoader(import('@src/assets/icons/eye.svg'));
  ;
import { forwardRef, useState } from 'react';
import { Pressable } from '@ui/atoms';
import useThemeColor from '@hooks/useThemeColor';

const PasswordInput = forwardRef(function PasswordInput(props, ref) {
  const [hidden, setHidden] = useState(true);
  const iconColor = useThemeColor('$grey.700');

  const toggle = (e) => {
    e.stopPropagation();
    setHidden((h) => !h);
  };

  return (
    <Input
      {...props}
      ref={ref}
      secureTextEntry={hidden}
      endIcon={
        <Pressable onPress={toggle} sx={{ alignItems: 'center', justifyContent: 'center' }}>
          {hidden ? (
            <EyeIcon width={24} height={24} color={iconColor} />
          ) : (
            <EyeSlashIcon width={24} height={24} color={iconColor} />
          )}
        </Pressable>
      }
    />
  );
});

export default PasswordInput;

        